import React from "react";
import { View, Text, StyleSheet, ScrollView } from "react-native";
import SvgIcon from '../components/SvgIcon';
import colors from "../theme/colors";
import { useNavigationVisibility } from '../context/NavigationVisibilityContext';

export default function HowItWorksScreen() {
  const { handleScroll } = useNavigationVisibility();
  
  return (
    <ScrollView 
      style={styles.container} 
      contentContainerStyle={styles.content}
      onScroll={handleScroll}
      scrollEventThrottle={16}
    >
      <View style={styles.journeySection}>
        <View style={styles.sectionHeader}>
          <Text style={styles.journeyTitle}>The Matchmaking Journey</Text>
          <View style={styles.titleUnderline} />
          <Text style={styles.journeySubtitle}>
            A time-tested process refined through generations of successful matchmaking
          </Text>
        </View>
        
        <View style={styles.journeySteps}>
          <View style={styles.journeyStep}>
            <View style={styles.stepNumberWrapper}>
              <View style={styles.stepNumberContainer}>
                <Text style={styles.stepNumber}>1</Text>
              </View>
              <View style={styles.stepLine} />
            </View>
            <View style={styles.stepContent}>
              <Text style={styles.stepTitle}>Profile & Consultation</Text>
              <Text style={styles.stepDescription}>
                Meet your mediator, create your profile and have an in-depth consultation about your preferences and family values.
              </Text>
            </View>
          </View>
          
          <View style={styles.journeyStep}>
            <View style={styles.stepNumberWrapper}>
              <View style={styles.stepNumberContainer}>
                <Text style={styles.stepNumber}>2</Text>
              </View>
              <View style={styles.stepLine} />
            </View>
            <View style={styles.stepContent}>
              <Text style={styles.stepTitle}>AI-Assisted Curation</Text>
              <Text style={styles.stepDescription}>
                Our AI analyzes compatibility while your mediator applies their wisdom to curate the most promising matches.
              </Text>
            </View>
          </View>
          
          <View style={styles.journeyStep}>
            <View style={styles.stepNumberWrapper}>
              <View style={styles.stepNumberContainer}>
                <Text style={styles.stepNumber}>3</Text>
              </View>
              <View style={styles.stepLine} />
            </View>
            <View style={styles.stepContent}>
              <Text style={styles.stepTitle}>Guided Meetings</Text>
              <Text style={styles.stepDescription}>
                Your mediator facilitates introductions and initial meetings, ensuring comfort and cultural appropriateness.
              </Text>
            </View>
          </View>
          
          <View style={styles.journeyStep}>
            <View style={styles.stepNumberWrapper}>
              <View style={styles.stepNumberContainer}>
                <Text style={styles.stepNumber}>4</Text>
              </View>
            </View>
            <View style={styles.stepContent}>
              <Text style={styles.stepTitle}>Blessed Union</Text>
              <Text style={styles.stepDescription}>
                With your mediator's continued support, celebrate your engagement and prepare for a lifetime of happiness together.
              </Text>
            </View>
          </View>
        </View>
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.primary,
  },
  content: {
    paddingBottom: 120,
  },
  journeySection: {
    width: "100%",
    paddingHorizontal: 24,
    paddingVertical: 50,
    backgroundColor: colors.primary,
  },
  sectionHeader: {
    alignItems: "center",
    marginBottom: 40,
  },
  journeyTitle: {
    fontSize: 32,
    fontWeight: "700",
    color: colors.white,
    textAlign: "center",
    marginBottom: 12,
  },
  titleUnderline: {
    width: 60,
    height: 4,
    backgroundColor: colors.secondary,
    borderRadius: 2,
    marginBottom: 12,
  },
  journeySubtitle: {
    fontSize: 16,
    color: colors.white,
    opacity: 0.8,
    textAlign: "center",
  },
  journeySteps: {
    gap: 24,
  },
  journeyStep: {
    flexDirection: "row",
    gap: 20,
  },
  stepNumberWrapper: {
    alignItems: "center",
  },
  stepNumberContainer: {
    width: 48,
    height: 48,
    borderRadius: 24,
    backgroundColor: colors.secondary,
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1,
  },
  stepLine: {
    width: 4,
    flex: 1,
    backgroundColor: colors.secondary,
    opacity: 0.3,
    marginTop: 4,
  },
  stepNumber: {
    fontSize: 20,
    fontWeight: "700",
    color: colors.white,
  },
  stepContent: {
    flex: 1,
  },
  stepTitle: {
    fontSize: 20,
    fontWeight: "600",
    color: colors.white,
    marginBottom: 8,
  },
  stepDescription: {
    fontSize: 15,
    color: colors.white,
    opacity: 0.8,
    lineHeight: 22,
  },
});
